/**********************************************************************************************************************/
/* FILE: hafas_webapp_renderinitial.js                                                                */
/**********************************************************************************************************************/

HafasWebapp.prototype.preloadTemplates = function (callback) {
  var templates = [
    // *** Überarbeitung Barrierefreiheit *** //
    'common.html',
    'common.new.html',
    'common.loading.html',
    'common.content.html',
    'common.page_header.html',
    'common.page_navigation.html',
    'common.actionbar.html',
    'common.buttons.html',
    'common.carousel.html',
    'common.links.html',
    'common.icons.html',
    'common.input.html',
    'common.input_datetime.html',
    'common.segmentedControl.html',
    'common.input_selectbox.html',
    'common.input_slider.html',
    'common.suggest.html',
    'common.options.html',
    'common.messages.html',
    'common.product.html',
    'common.pagination.html',
    'common.map.html',
    'tq.result.html',
    'map.flyout.html'
  ];
  if (Hafas.Config.Switches.useTravelplanner || Hafas.Config.MapSearch.use) {
    templates.push('tp.form.input.html');
  }
  if (Hafas.Config.Switches.useStationboard) {
    templates.push('sq.index.html');
    templates.push('sq.form.fields_favorites.html');
    templates.push('sq.result.html');
    templates.push('sq.result.lineGroup.html');
    templates.push('sq.result.info.html');
    templates.push('sq.result.print.html');
  }
  if (Hafas.Config.Switches.useTravelplanner) {
    templates.push('tp.result.html');
    templates.push('tp.result.error.html');
    templates.push('tp.form.fields_favorites.html');
    templates.push('tp.result.overview.html');
    templates.push('tp.result.overview_oev.html');
    templates.push('tp.result.overview_cluster.html');
    templates.push('tp.result.detail.html');
  }
  if (Hafas.Config.Tariffs.show == true) {
    templates.push('tariffs.index.html');
  }
  if ((Hafas.Config.TP && Hafas.Config.TP.serviceDays && Hafas.Config.TP.serviceDays.show) || (Hafas.Config.TQ && Hafas.Config.TQ.serviceDays && Hafas.Config.TQ.serviceDays.show)){
    templates.push(('common.serviceDays.html'));
  }
  if (Hafas.Config.Switches.useImprint) {
    templates.push('imprint.index.html');
  }
  if (Hafas.Config.Switches.useReachability) {
    templates.push('reachability.index.html');
    templates.push('reachability.form.input.html');
    templates.push('reachability.form.fields_favorites.html');
  }
  if(Hafas.Config.Switches.usePush){
    templates.push('push.index.html');
  }
  if (Hafas.Config.Switches.useSmartLocations === true){
    templates.push('common.smartlocations.html');
  }

  Hafas.Modules.Loader.loadTemplateFiles(templates, function () {
    callback();
  });
};

/* renderInitialElements */
HafasWebapp.prototype.renderInitialElements = function () {
  // Render PageHeader

  var _me = this;
  var modelPage = {};
  modelPage.languages = (Hafas.Config.Switches.useLanguageSwitch) ? [] : false;
  if (modelPage.languages) {
    var langIdx = 0,
      langLen = Hafas.Config.languages.length;
    for (langIdx; langIdx < langLen; langIdx++) {
      var lang = Hafas.Config.languages[langIdx];
      lang.label = Hafas.Modules.i18n.get(lang.label);
      if (Hafas.Config.currLangObj.lang == lang.lang) {
        lang.isActive = true;
      }
      modelPage.languages.push(lang);
    }
  }

  /**
   * Erweiterung des Hafas.Config-Objekts mit Angaben zum Navigator
   * Hafas.Config.Navigator wird um canIUseNativeInputfields erweitert
   *
   * Wird fuer die Abfrage in den Formularen gebraucht, ob native Felder gerendert werden sollen oder nicht.
   * Wird aber nur dann ueberprueft, wenn in der config.json useDTPNativeFallback auf "true" gesetzt ist.
   *
   * Geprueft wird hier auf verschiedene Eigenschaften des Browser.
   * Desktop-Browser und das Surface verfuegen nicht ueber window.orientation
   * Ipad, iPhone und Motorola Zoom mit Android 5.0 allerdings schon
   *
   * Besonderheit: Es wird noch nach dem pointerEnabled-Wert gefragt. Bis jetzt ist er nur mit dem Surface
   * aufgetaucht und auch da nur mit dem Edge! Aber auch hier wollen wir keine nativen Felder.
   */
  if (Hafas.Config.UI.useDTPNativeFallback === true) {
    if (typeof window.orientation != 'undefined') {
      Hafas.Config.Navigator.canIUseNativeInputfields = true;
    }
    else {
      Hafas.Config.Navigator.canIUseNativeInputfields = false;
    }
    // ueberpruefe ob Hafas.Config.Navigator.pointerEnabled vorhanden ist
    // Bis jetzt hat nur das Surface mit Edge den Wert true gesetzt, alle anderen waren undefined
    if (typeof Hafas.Config.Navigator.pointerEnabled != 'undefined' && Hafas.Config.Navigator.pointerEnabled) {
      Hafas.Config.Navigator.canIUseNativeInputfields = false;
    }
  }
  else {
    Hafas.Config.Navigator.canIUseNativeInputfields = false;
  }

  /* Navigation aufbauen */
  modelPage.navigation = {};
  modelPage.navigation.showLanguages = false;
  modelPage.navigation.languages = modelPage.languages;

  modelPage.navigation.showColorSchemeButton = false;
  if (Hafas.Config.Switches.useColorTheming && Hafas.Config.ColorScheme.showSwitch && (!Hafas.Util.appIsInIFrame() || !Hafas.Config.iframeApiEnabled)) {
    modelPage.navigation.showColorSchemeButton = true;
  }

  // Hafas.Config.UI.showPageHeader == true: es wird nur das Kundenlogo im Header angezeigt, die sichtbar geschalteten Men�-Punkte befinden sich in den Tabs, der Rest im Seitenmen�
  // Hafas.Config.UI.showPageHeader == false: Das Standard-Verhalten f�r Desktop, nur die Navigationsreiter und das Seitenmen� werden angezeigt
  if (Hafas.Config.UI.showPanCakeMenu && (Hafas.Config.Switches.useTabNavigationDesktop || Hafas.Config.Switches.useTabNavigationMobile)) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
    modelPage.navigation.pageNavigation = Hafas.Config.headerNavigation;
  }

  // Hafas.Config.UI.showPageHeader == true: es wird nur das Kundenlogo im Header angezeigt, alle anderen Men�punkte befinden sich im Seitenmen�
  // Hafas.Config.UI.showPageHeader == false: kein Header, �ber dem Formular wird eine �berschrift mit dem aktuellen Konzext angezeigt, alle Men�punkte befinden sich im Seitenmen�
  if (Hafas.Config.UI.showPanCakeMenu && !Hafas.Config.Switches.useTabNavigationDesktop && !Hafas.Config.Switches.useTabNavigationMobile) {
    modelPage.navigation.pageNavigation = Hafas.Config.headerNavigation;
  }

  // �ber dem Formular wird nur der Titel des aktuellen Kontexts angezeigt, es gibt keine Navigation
  if (!Hafas.Config.UI.showPanCakeMenu && !Hafas.Config.UI.showPageHeader && !Hafas.Config.Switches.useTabNavigationDesktop && !Hafas.Config.Switches.useTabNavigationMobile) {
    // keine Men�punkte
  }

  // Die sichtbar geschalteten Men�-Punkte befinden sich in den Tabs, alle anderen im PageHeader
  if (!Hafas.Config.UI.showPanCakeMenu && Hafas.Config.UI.showPageHeader && (Hafas.Config.Switches.useTabNavigationDesktop || Hafas.Config.Switches.useTabNavigationMobile)) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
    modelPage.navigation.headerNavigation = Hafas.Config.headerNavigation;
    modelPage.navigation.showLanguages = true;
  }

  // Alle Men�punkte werden im Header angezeigt, keine Tab-Navigation, �ber dem Formular wird der Titel des aktuellen Kontext angezeigt
  if (!Hafas.Config.UI.showPanCakeMenu && Hafas.Config.UI.showPageHeader && !Hafas.Config.Switches.useTabNavigationDesktop && !Hafas.Config.Switches.useTabNavigationMobile) {
    modelPage.navigation.headerNavigation = Hafas.Config.headerNavigation;
    modelPage.navigation.showLanguages = true;
  }

  // Nur die sichtbar konfigurierten Tabs werden angezeigt, keine weiteren Men�punkte (Sprachumschaltung fehlt dann)
  if (!Hafas.Config.UI.showPanCakeMenu && !Hafas.Config.UI.showPageHeader && (Hafas.Config.Switches.useTabNavigationDesktop || Hafas.Config.Switches.useTabNavigationMobile)) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
  }

  var me = this;
  if (modelPage.navigation.hasOwnProperty('pageNavigation')) {
    // In terminal mode, remove links that do not open in an overlay
    // URL params have not been evaluated in JumpIn module yet, so check URL parameters in addition to config switch
    var hasTerminalModeParam = window.location.search.includes('useTerminalMode=true') || window.location.hash.includes('useTerminalMode|true'); // Access of location.search OK, as value is not used but set by includes function
    if (Hafas.Config.Switches.useTerminalMode && hasTerminalModeParam) {
      modelPage.navigation.pageNavigation = modelPage.navigation.pageNavigation.filter(item => item.type !== 'EXT_LINK');
    }
    // Aufl�sung der Sprach-Keys aus der Config-Datei
    modelPage.navigation.pageNavigation.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }

  // Aufl�sung der Sprach-Keys aus der Config-Datei
  if (modelPage.navigation.hasOwnProperty('headerNavigation')) {
    modelPage.navigation.headerNavigation.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }

  if (Hafas.Config.UI.showPageHeader) {
    /* Render PageHeader navigation */
    // Hafas.Modules.Render.render({
    //   file: 'common.page_header.html',
    //   target: 'HFS_PageHeader',
    //   template: 'Common_AtomTplPageHeader',
    //   model: modelPage.navigation
    // }, Hafas.bind(function (html) {
    // }, this));

    // Neu Strawberry 1.5.0.2
    Hafas("#HFS_PageHeader").innerHTML = Hafas.Modules.Render.renderTemplate("Common_AtomTplPageHeader", modelPage.navigation);
  }

  if (typeof modelPage.navigation.tabs != 'undefined' && modelPage.navigation.tabs.length > 0) {
    /* replace i18n-keys */
    modelPage.navigation.tabs.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }
  var $menuContainer = Hafas('#HFS_FlyInMenuContainer_Panel', false);
  $menuContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_AtomTplPancakeMenu", modelPage.navigation);
  // Neu Strawberry 1.5.0.2
  var $navContainer = Hafas('#HFS_TabNavigation', false);
  $navContainer.innerHTML = Hafas.Modules.Render.renderTemplate("Common_AtomTplPageNavigation", modelPage.navigation);
  $navContainer.removeAttribute('hidden');
  if (Hafas.Config.Switches.useTabNavigationDesktop === false && Hafas.Config.Switches.useTabNavigationMobile === false && Hafas.Config.UI.showTabNavigationHeading === true) {
    // Keine TabNavigation vorhanden, dafür aber die TabNavigationHeading: Hole die TabNavHeading in die Zeile des Burger-Menu-Items
    $navContainer.classList.add('lyr_tabNavigationFlex');
  }
  if (Hafas.Config.Switches.useTabNavigationMobile === true) {
    // Keine TabNavigation vorhanden, dafür aber die TabNavigationHeading: Hole die TabNavHeading in die Zeile des Burger-Menu-Items
    $navContainer.classList.add('lyr_layoutSmallShow');
  }



  Hafas.ps.pub('/GUI/pageHeaderRendered');

};
